<template>
  <div class="scene signup flex-r">
    <div class="section size-50" />

    <div id="step-container" class="size-40">
      <div class="signup-form-bg shadow-large">
        <h1>
          Заполните информацию о компании
        </h1>

        <base-input
          v-model.trim="$v.signUpCredentials.project.firstName.$model"
          :is-have-error="$v.signUpCredentials.project.firstName.$error"
          label="Имя"
          placeholder="Артём"
        >
          <div
            v-if="$v.signUpCredentials.project.firstName.$error"
            class="f-input-text"
          >
            <template v-if="!$v.signUpCredentials.project.firstName.required">
              Имя обязателено.
            </template>

            <template v-else-if="!$v.signUpCredentials.project.firstName.name">
              Введите существующее имя
            </template>
          </div>
        </base-input>

        <base-input
          v-model.trim="$v.signUpCredentials.project.lastName.$model"
          :is-have-error="$v.signUpCredentials.project.lastName.$error"
          label="Фамилия"
          placeholder="Наумов"
        >
          <div
            v-if="$v.signUpCredentials.project.lastName.$error"
            class="f-input-text"
          >
            <template v-if="!$v.signUpCredentials.project.lastName.required">
              Фамилия обязателена.
            </template>

            <template v-else-if="!$v.signUpCredentials.project.lastName.name">
              Введите существующую фамилию
            </template>
          </div>
        </base-input>

        <base-input
          v-model.trim="$v.signUpCredentials.project.thirdName.$model"
          :is-have-error="$v.signUpCredentials.project.thirdName.$error"
          label="Отчество"
          placeholder="Дмитриевич"
        >
          <div
            v-if="$v.signUpCredentials.project.thirdName.$error"
            class="f-input-text"
          >
            <template v-if="!$v.signUpCredentials.project.thirdName.required">
              Отчество обязателено.
            </template>

            <template v-else-if="!$v.signUpCredentials.project.thirdName.name">
              Введите существующее отчество
            </template>
          </div>
        </base-input>

        <base-input
          v-model.trim="$v.signUpCredentials.project.legalAddress.$model"
          :is-have-error="$v.signUpCredentials.project.legalAddress.$error"
          label="Адрес регистрации"
          placeholder="г. Минск, улица Шаранговича 67. офис 303"
        >
          <div
            v-if="$v.signUpCredentials.project.legalAddress.$error && !$v.signUpCredentials.project.legalAddress.required"
            class="f-input-text"
          >
            Адрес регистрации обязателен.
          </div>
        </base-input>

        <base-input
          v-model.trim="$v.signUpCredentials.project.checkingAccountIBAN.$model"
          :is-have-error="$v.signUpCredentials.project.checkingAccountIBAN.$error"
          label="Расчётный счёт IBAN"
          placeholder="BY11 ALFA 3012 2259 6801 6027 0000"
        >
          <div
            v-if="$v.signUpCredentials.project.checkingAccountIBAN.$error"
            class="f-input-text"
          >
            <template v-if="!$v.signUpCredentials.project.checkingAccountIBAN.checkingAccountIBAN">
              Невалидный расчётный счёт IBAN
            </template>
          </div>
        </base-input>

        <base-input
          v-model.trim="$v.signUpCredentials.project.bankBicCode.$model"
          :is-have-error="$v.signUpCredentials.project.bankBicCode.$error"
          label="Код банка BIC"
          placeholder="ALFABY2X"
        >
          <div
            v-if="$v.signUpCredentials.project.bankBicCode.$error"
            class="f-input-text"
          >
            <template v-if="!$v.signUpCredentials.project.bankBicCode.required">
              Код банка BIC обязателен.
            </template>

            <template v-else-if="!$v.signUpCredentials.project.bankBicCode.bicCode">
              Невалидный код банка BIC
            </template>
          </div>
        </base-input>

        <base-input
          v-model.trim="$v.signUpCredentials.project.bankName.$model"
          :is-have-error="$v.signUpCredentials.project.bankName.$error"
          label="Банк"
          placeholder='"ЗАО "Альфа-Банк"'
        >
          <div
            v-if="$v.signUpCredentials.project.bankName.$error && !$v.signUpCredentials.project.bankName.required"
            class="f-input-text"
          >
            Название банка обязательно.
          </div>
        </base-input>

        <base-input
          v-model.trim="$v.signUpCredentials.project.bankAddress.$model"
          :is-have-error="$v.signUpCredentials.project.bankAddress.$error"
          label="Адрес банка"
          placeholder="г. Минск, ул. Притыцкого, 97"
        >
          <div
            v-if="$v.signUpCredentials.project.bankAddress.$error && !$v.signUpCredentials.project.bankAddress.required"
            class="f-input-text"
          >
            Адрес банка обязателен.
          </div>
        </base-input>

        <base-input
          v-model.trim="$v.signUpCredentials.project.phone.$model"
          :is-have-error="$v.signUpCredentials.project.phone.$error"
          label="Телефон"
          placeholder="+375 XX XXX-XX-XX"
        >
          <div
            v-if="$v.signUpCredentials.project.phone.$error"
            class="f-input-text"
          >
            <template v-if="!$v.signUpCredentials.project.phone.required">
              Телефон обязателен.
            </template>

            <template v-else-if="!$v.signUpCredentials.project.phone.phone">
              Невалидный телефон
            </template>
          </div>
        </base-input>

        <base-input
          v-model.trim="$v.signUpCredentials.project.email.$model"
          :is-have-error="$v.signUpCredentials.project.email.$error"
          label="E-mail"
          placeholder="email@justreserve.me"
        >
          <div
            v-if="$v.signUpCredentials.project.email.$error"
            class="f-input-text"
          >
            <template v-if="!$v.signUpCredentials.project.email.required">
              E-mail обязателен.
            </template>

            <template v-else-if="!$v.signUpCredentials.project.email.email">
              Невалидный email
            </template>
          </div>
        </base-input>

        <vue-dropzone
          ref="dropzone"
          id="dropzone"
          :options="dropzoneOptions"
          :useCustomSlot="true"
          class="f-input"
          :class="{ error: $v.signUpCredentials.documents.$error }"
          @vdropzone-success="handleDropzoneFileSuccessUploaded"
          @vdropzone-removed-file="handleDropzoneFileWasRemoved"
        >
          <div class="dz-message-image">
            <img src="/img/svg/docs-placeholder.svg">
          </div>
          <div class="dz-message-header">
            Перетащите сюда фото паспорта, или воспользуйтесь
            <br>
            файловым менеджером
          </div>

          <div class="dz-message-desc">
            Поддерживаемые форматы: JPG, PNG, BMP.
          </div>

          <button class="button primary">
            <span class="text">Загрузить документ</span>

          </button>

          <div
            v-if="$v.signUpCredentials.documents.$error && !$v.signUpCredentials.documents.required"
            class="f-input-text"
          >
            Документ, подтверждающий личность, обязателен
          </div>
        </vue-dropzone>


        <h2 style="margin-top:100px;">
          На основе этих данных будут создано заведение
        </h2>

        <base-input
          v-model.trim="$v.signUpCredentials.place.name.$model"
          :is-have-error="$v.signUpCredentials.place.name.$error"
          label="Название заведения"
          placeholder="Just Reserve"
        >
          <div
            v-if="$v.signUpCredentials.place.name.$error && !$v.signUpCredentials.place.name.required"
            class="f-input-text"
          >
            Навание заведения обязателено.
          </div>
        </base-input>

        <base-input
          v-model.trim="$v.signUpCredentials.place.address.$model"
          :is-have-error="$v.signUpCredentials.place.address.$error"
          label="Адрес заведения"
          placeholder="улица Шаранговича 67"
        >
          <div
            v-if="$v.signUpCredentials.place.address.$error && !$v.signUpCredentials.place.address.required"
            class="f-input-text"
          >
            Адрес заведения обязателен.
          </div>
        </base-input>

        <div class="signup-form-buttons flex-r">
          <div class="section size-50">
            <div
              class="button"
              @click="emitBackEvent"
            >
              <div class="text">
                Назад
              </div>
            </div>
          </div>

          <div class="section size-50 txt-algn-r">
            <div
              class="button primary"
              :class="{ disabled: $v.$invalid }"
              @click="setFilledProjectAndContractorInformation"
            >
              <div class="text">
                Следующий шаг
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="isOnboardingShow"
          style="position: absolute; height: 100%; width: 100%; top: 0; left: 0; background-color: rgba(255,255,255,.97); padding: 80px 30px; border-radius: 50px;"
        >
          <div class="flex-c">
            <div class="section size-10"></div>
            <div class="section size-80">
              <h1>
                В данный момент онлайн-регистрация находится в режиме тестирования, но вы можете
                приехать к нам в офис для заключения договора в любой рабочий день.
                <br>
                <br>
                Все вопросы по телефону <span class="nowrap">+375 25 956-75-54</span>.
              </h1>

              <div class="button" @click="closeOnboarding">
                CLOSE
              </div>
            </div>
            <div class="section size-10"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="section size-10" />
  </div>
</template>

<script>
// Todo: rewrite this shit component
import vueDropzone from 'vue2-dropzone';
import { required } from 'vuelidate/lib/validators';
import { AsYouType } from 'libphonenumber-js';
import projectValidationModel from '@/validators/model/individualProject';
import placeValidationModel from '@/validators/model/place';
import cloneDeep from 'lodash.clonedeep';
import IBAN from 'fast-iban';

export default {
  name: 'FillIndividualProjectInformationStep',
  validations: {
    signUpCredentials: {
      project: projectValidationModel,
      place: placeValidationModel,
      documents: {
        required
      }
    }
  },
  components: {
    vueDropzone
  },
  props: {
    initSignUpCredentials: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      signUpCredentials: cloneDeep(this.initSignUpCredentials),
      dropzoneOptions: {
        url: this.$generateAbsolutePath('/file/upload'),
        thumbnailWidth: 150,
        addRemoveLinks: true,
        acceptedFiles: 'image/*'
      },
      isOnboardingShow: true
    }
  },
  watch: {
    'signUpCredentials.project.checkingAccountIBAN'(checkingAccountIBAN) {
      if (checkingAccountIBAN) {
        const formattedIBAN = IBAN.formatIBAN(checkingAccountIBAN);

        if (formattedIBAN !== checkingAccountIBAN) {
          this.signUpCredentials.project.checkingAccountIBAN = formattedIBAN;
        }
      }
    },
    'signUpCredentials.project.phone'(phone) {
      const formattedPhone = new AsYouType().input(phone);

      if (formattedPhone !== phone) {
        this.signUpCredentials.project.phone = formattedPhone;
      }
    }
  },
  mounted() {
    for (let index = 0; index < this.signUpCredentials.documents.length; index++) {
      const image = this.signUpCredentials.documents[index];

      this.$refs.dropzone.manuallyAddFile(
        image.file,
        this.$generateAbsolutePath(image.path)
      );
    }

    this.signUpCredentials.project.documentTypes = [8];
  },
  methods: {
    handleDropzoneFileSuccessUploaded(file, response) {
      this.signUpCredentials.documents.push({
        ...response,
        file
      });
    },
    handleDropzoneFileWasRemoved(removedFile) {
      const imageIndex = this.signUpCredentials.documents.findIndex(({ file }) => file === removedFile);

      if (imageIndex !== -1) {
        this.signUpCredentials.documents.splice(imageIndex, 1);
      }
    },
    setFilledProjectAndContractorInformation() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.$emit('next', cloneDeep(this.signUpCredentials));
      }
    },
    emitBackEvent() {
      this.$emit('back', cloneDeep(this.signUpCredentials));
    },
    closeOnboarding() {
      if (window.confirm('Вы точно хотите продолжить?')) {
        this.isOnboardingShow = false;
      }
    }
  }
}
</script>

<style>
  @import "~vue2-dropzone/dist/vue2Dropzone.min.css";
</style>
